import { ab } from "../public/js/core/abMock";
import { getRandomNumeric, getRegionMap } from "./CommonUtils";

export function populateHeader(data, header) {
  const { isGoibibo = false, dvid } = data || {};

  const headersMap = { ...header };
  const mcid = dvid;
  const deviceId = dvid;
  const appVer = "app-ver";
  const devId = "device-id";
  headersMap[appVer] = "1.0.0";
  headersMap.os = "Linux";
  headersMap.pfm = "DESKTOP";
  headersMap.src = isGoibibo ? "gi" : "mmt";
  headersMap.mcid = mcid;
  headersMap[devId] = deviceId;
  headersMap.Accept = "application/json";
  headersMap.source = isGoibibo ? "GI" : "MMT";
  headersMap.lob = "B2C";
  if (!isGoibibo) {
    headersMap.ab = JSON.stringify(ab.data);
  }

  const regionMap = getRegionMap("headers", data) || {};
  return { ...headersMap, ...regionMap };
}
